export default "__VITE_ASSET__PuEOgl____"